<template>
  <div class="sidemenu-slideout-menu" @click="closeMenu">
    <div class="sidemenu-content">
      <div class="close-side-bar">
        <svgicon name="cancelblack" width="15" height="15" :original="true" />
      </div>
      <div class="menu-profile">
        <div @click="gotoProfile" class="menu-profile-icon">
          <span v-if="currUser && currUser.name[0]"/>
          <svgicon v-else name="icon-user" width="20" height="24" :original="true" />
        </div>
        <div class="menu-profile-name">{{currUser && currUser.name}}</div>
        <div class="menu-profile-log-out">
          <a href="javascript:void(0)" @click="logout">
            LOG OUT
          </a>
        </div>
      </div>
      <ul>
        <li class="sidemenu-slideout-menu-item" v-for="(list,index) in getMenuItems" :key="index">
          <router-link :to="{ name: list.routerLink }">
            <svgicon :name="list.icon" class="dropdown-icon" width="20"
              height="20" :original="true" /> {{list.name}}
          </router-link>
        </li>
        <li v-if="$hasFeature('return_management')"
          @click="$emit('close')"
          class="sidemenu-slideout-menu-item">
          <router-link :to="{ name: 'Deliveries'}">
            <svgicon name="contract"
              class="dropdown-icon" width="20"
              height="20" :original="true" /> {{$t('PLANNING')}}
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script type="text/javascript">
import { mapGetters } from 'vuex';
import { Menu } from '@/constants/payments';
import menuItems from '@/constants/sidebar';
import { MDMMenu } from '@/constants/mdm-v2/header';

export default {
  data() {
    return {
      isOpen: false,
      menuItems,
      Menu,
      MDMMenu,
    };
  },
  computed: {
    ...mapGetters({
      configurations: 'app/currentClientConfig',
      currUser: 'app/currentUser',
    }),
    getMenuItems() {
      let list = this.menuItems.filter(element =>
        (element.feature ? this.$hasFeature(element.feature) : true) &&
        (element.permission ? this.$hasPermission(element.permission) : true) &&
        (element.config ? this.configurations[element.config] : true) &&
        (element.not_config ? !this.configurations[element.not_config] : true));
      list = list.map((element) => {
        const item = element;
        if (item.id === 'mdm') {
          item.router_link = [{ link: this.mdmRouteSection }];
        }
        item.routerLink = item.router_link.filter(link =>
          (link.feature ? this.$hasFeature(link.feature) : true));
        item.routerLink = (item.routerLink && item.routerLink[0]) ? item.routerLink[0].link : null;
        return item;
      });
      return list;
    },
    mdmRouteSection() {
      if (this.MDMMenu) {
        for (let i = 0; i < this.MDMMenu.length; i += 1) {
          const menu = this.MDMMenu[i];
          if ((!menu.permission || this.$hasPermission(menu.permission)) &&
            (menu.config ? this.configurations[menu.config] : true)) {
            return menu.id;
          }
        }
      }
      return '';
    },
  },
  methods: {
    gotoProfile() {
      this.$router.push({ name: 'Profile' });
    },
    async logout() {
      try {
        const optimaHeaders = localStorage.getItem('Optima-selected-headers');
        const optimaInputPageHeaders = localStorage.getItem('optima-input-selected-headers');
        const result = await this.$store.dispatch('app/logout', { data: {} });
        const tableParameters = localStorage.getItem('tableParameters');
        localStorage.clear();
        if (tableParameters) {
          localStorage.setItem('tableParameters', tableParameters);
        }
        if (optimaHeaders) {
          localStorage.setItem('Optima-selected-headers', optimaHeaders);
        }
        if (optimaInputPageHeaders) {
          localStorage.setItem('optima-input-selected-headers', optimaInputPageHeaders);
        }
        localStorage.setItem('tsm-transporter-token', '');
        this.$router.push({ name: 'Login' });
        return result;
      } catch (err) {
        return err;
      }
    },
    closeMenu() {
      this.$emit('close');
    },
  },
};
</script>
<style lang="scss" scoped>
.close-side-bar {
  position: relative;
  top: -8px;
  left: 48px;
  cursor: pointer;
}
</style>
